// Display name for a locador/locatario: "Apellido Nombre".
// Records are loaded with apellido and nombre separately, but shown joined.
// Legacy records only have `nombre` (the apellido is empty) — in that case this
// returns the `nombre` exactly as before, so existing data keeps rendering the
// same until someone edits it and fills in the apellido.
export const nombreCompleto = (p) =>
  [p?.apellido, p?.nombre]
    .map((s) => String(s || "").trim())
    .filter(Boolean)
    .join(" ");

// Clave vieja de dedup: el nombre completo en minúsculas con espacios colapsados.
// Sigue existiendo porque hay registros guardados con esta clave; se usa como
// segundo intento al buscar duplicados (ver saveLocador/saveLocatario).
export const legacyNormalizeNombre = (apellido, nombre) =>
  nombreCompleto({ apellido, nombre }).toLowerCase().replace(/\s+/g, " ").trim();

// Clave de dedup/búsqueda. Además de minúsculas y espacios, saca los acentos y
// ordena las palabras alfabéticamente, así "Alfonsín Mariela", "Alfonsin Mariela"
// y "Mariela Alfonsin" caen todas en la misma clave y no se duplica el registro.
export const normalizeNombre = (apellido, nombre) =>
  legacyNormalizeNombre(apellido, nombre)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .split(" ")
    .filter(Boolean)
    .sort()
    .join(" ");
